/**
 * 
 * File Upload Box
 * 
 */

import React from 'react';
import { UPLOAD_NAME_CONCAT } from '../../utility';
import axios from '../../../axios-url';
import { Toast } from 'primereact/toast';
import moment from 'moment';

class FileUploadBox extends React.Component {

    state = {
        loading: false,
        attachmentData: []
    }


    onBasicUploadAuto = (e) => {
        const fileupload = document.getElementById(this.props.name);
        if (fileupload)
            fileupload.click();
    }

    addAttachmentContainer = (e) => {
        e.preventDefault();
        const { name: inputName, onInputChange } = this.props;
        this.setState({ loading: true });
        let file = e.target.files[0];
        let name = 'Attachments_' + UPLOAD_NAME_CONCAT + '_' + file.name;
        const frmData = new FormData();
        frmData.append('file', file, name);

        return axios.post('/master/api/upload?FolderName=LeaveRequestAttachments', frmData).then(response => {
            let filePath = response.data.filePath;
            let fileName = response.data.fileName;
            const jhj = Object.assign({}, { target: Object.assign({}, { name: inputName, type: 'file', value: fileName }), preventDefault: () => { } });
            onInputChange(jhj);
            this.setState({ loading: false });

        }).catch(err => {
            this.growl.show({ severity: 'error', summary: null, detail: 'File Upload Failed' });
            this.setState({ loading: false });
        })
    }

    render() {
        const { name, label, value, placeholder, fieldStatus, defaultValue, disabled } = this.props;
        const display = fieldStatus && fieldStatus === "Display Only";

        return (<div className="p-col-12">
            <Toast ref={(el) => this.growl = el} />
            {!display ? <label className="label">
                {label}
                <span className="requiredColor">*</span>
            </label> : null}
            <div className={display ? "mt3" : "mt1"}>
                {display ?
                    <div>  {`${label}: ${isNaN(Date.parse(value)) ? value : moment(value).format('MM/DD/YYYY')}`}</div> :
                    <div>
                        <input id={name} name={name} type="file" onChange={(e) => this.addAttachmentContainer(e)} accept="image/*" style={{display: 'none'}} />
                        {!value && <span className="p-button p-component p-fileupload-choose" onClick={this.onBasicUploadAuto} tabindex="0">
                            <span className="p-button-icon p-button-icon-left pi pi-plus"></span>
                            <span className="p-button-label p-clickable">Choose </span>
                            <span class="p-ink" style={{ height: '98px', width: '98px', top: '-32.5313px', left: '26.0278px' }} />
                        </span> || <span className="p-button p-component p-fileupload-choose p-fileupload-choose-selected" onClick={this.onBasicUploadAuto} tabindex="0">
                                <span className="p-button-icon p-button-icon-left pi pi-upload" />
                                <span className="p-button-label p-clickable">{value && typeof value === 'string' && value.substring(value.lastIndexOf(`\\`) + 1) || ''}</span>
                                <span className="p-ink" style={{ height: '98px', width: '98px', top: '-31.5313px', left: '0.027771px' }} />
                            </span>}
                    </div>}
            </div>
        </div>)
    }
}


export default FileUploadBox;